import cn from 'classnames';
import { MacOSIcon, PlayIcon } from '#assets/ReactSvg.ts';
import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import styles from './AppStoreButtons.module.css';

type Props = {
  iosURL?: string;
  androidURL?: string;
  className?: string;
};

export function AppStoreButtons({ iosURL, androidURL, className }: Props) {
  return (
    <div className={cn(styles.AppStoreButtons, className)}>
      {iosURL ?
        <LinkButton
          variant="secondary"
          size="medium"
          href={iosURL}
          target="_blank"
          rel="noreferrer"
          className={styles.AppStoreButtons_button}
        >
          <MacOSIcon className={styles.AppStoreButtons_icon} aria-hidden="true" />
          <span className={styles.AppStoreButtons_label}>
            <span className={styles.AppStoreButtons_platform}>iPhone &amp; iPad</span>
            <span className={styles.AppStoreButtons_store}>App Store</span>
          </span>
        </LinkButton>
      : null}
      {androidURL ?
        <LinkButton
          variant="secondary"
          size="medium"
          href={androidURL}
          target="_blank"
          rel="noreferrer"
          className={styles.AppStoreButtons_button}
        >
          <PlayIcon className={styles.AppStoreButtons_icon} aria-hidden="true" />
          <span className={styles.AppStoreButtons_label}>
            <span className={styles.AppStoreButtons_platform}>Android</span>
            <span className={styles.AppStoreButtons_store}>Google Play</span>
          </span>
        </LinkButton>
      : null}
    </div>
  );
}
